<axis-hero-banner
  title="Reliable Plumbing & Heating Solutions You Can Trust"
  subtitle="Expert plumbing and gas services for homes and businesses, delivered with professionalism and care."
  backgroundImage="https://goodbeeplumbinganddrains.com/wp-content/uploads/2023/01/iStock-1341381755.jpg"
  buttonText="Call Now"
  buttonLink="tel:+447506113669"
  secondaryButtonText="Book Now"
  secondaryButtonLink="/contact"
>
</axis-hero-banner>

<axis-featured-services
  [services]="featuredServices"
  [servicesPageLink]="'/services'"
  [showViewMore]="true"
  [buttonText]="'All Services'"
></axis-featured-services>

<axis-banner-break
  title="Emergency Plumbing Support"
  text="Call us now for immediate assistance – we're available 24/7."
  ctaLabel="Call Now"
  ctaLink="tel:+447506113669"
>
</axis-banner-break>

<axis-how-it-works
  [title]="'What To Expect'"
  [steps]="[
  {
    number: '1',
    title: 'Create an account',
    description: 'Create an account to get started with Axis.',
  },
  {
    number: '2',
    title: 'Create an account',
    description: 'Create an account to get started with Axis.',
  },
  {
    number: '3',
    title: 'Create an account',
    description: 'Create an account to get started with Axis.',
  },
]"
></axis-how-it-works>

<axis-contact-hero-banner
  displayType="image"
  mapImageUrl="/images/map.png"
  heroTitle="Reliable Plumbing & Heating Experts"
  heroSubtitle="Fast, professional service for homes and businesses—24/7 emergency call-outs available."
  [contactDetails]="contactDetails"
  [contactInfoSections]="contactInfoSections"
></axis-contact-hero-banner>

<axis-g-reviews-section [reviews]="reviews"></axis-g-reviews-section>
